// import { setYoutube } from "./youtube.js";
import 'promise-polyfill/src/polyfill';
import './polyfills/required';
import lazyload from './lazyload.js';

import civicCookie from './civic-cookie';
import newsloader from './newsloader';
import addShareUrls from './share-classes';
import overlay from './menu-overlay';
import videoAutoplay from './video-autoplay';
import activateSubmenus from './submenu';
import slider from 'liteslider';
import adjustInPageScrollPosition from './adjustScroll';
import equaliseHeights from './equalise-heights';
import personalisationScriptLoad from './personalisation.js';
import bannerCss from './banner-css.js';
import shortsModal from 'youtube-shorts';
import {setupIframeSizer, setupIframeMessenger} from './iframesizer.js';

bannerCss();
addShareUrls();
civicCookie();
lazyload();
newsloader();
overlay();
videoAutoplay();
activateSubmenus();
personalisationScriptLoad();
shortsModal();
setupIframeMessenger();
setupIframeSizer('[data-frame="resize"]');

slider({
  container: '.slider-logo',
  responsive: {
    0: {
      items: 3,
      gutter: 20,
    },
    768: {
      items: 6,
      gutter: 20,
    },
  },
});
adjustInPageScrollPosition();

equaliseHeights(
    '.testimonial-carousel .carousel-inner',
    '.carousel-item',
    'active');

const ytSelector = '[data-youtube-id]';
const ytEls = document.querySelectorAll(ytSelector);

if (ytEls.length > 0) {
  import(/* webpackChunkName: "youtube-player" */ './youtubePlayer')
      .then(({default: setup}) => {
        setup(ytSelector);
      });
};

(function() {
  const items = document.querySelectorAll('.cookie-preferences-trigger');

  items.forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();
      CookieControl.open();
    });
  });
})();

(function() {
  const items = document.querySelectorAll('.rTapLink');
  items.forEach((item) => {
    item.addEventListener('click', (event) => {
      rTapClickToCall(238697);
    });
  });
})();

// add class to document if the dismiss banner cookie has been set

(function() {
  const cookies = document.cookie.split('; ');
  const doc = document.querySelector('.banner-alert');
  if (!doc) return;
  if (!cookies.includes('banner_dismissed=true')) {
    doc.classList.add('show-banner-alert');
  } else {
    doc.classList.remove('show-banner-alert');
  }
})();

document.addEventListener('click', function(event) {
  const target = event.target;

  if (target.parentNode !== document &&
    target.parentNode.getAttribute('aria-label') === 'Close' &&
    target.parentNode.tagName === 'BUTTON') {
    if (target.closest('.close')) {
      document.cookie = 'banner_dismissed=true; SameSite=Lax; expires=Session; path=/';
    };
  };
});

(function() {
  const searchTriggers = document.querySelectorAll(
      '.sitewide-search-form-search-trigger');
  searchTriggers.forEach((el) => {
    el.addEventListener('click', function(event) {
      const form = el.closest('form');
      form.submit();
    });
  });
})();

(function() {
  const els = document.querySelectorAll('.rTapPlaceholder');

  els.forEach(((item) => {
    item;

    const link = document.createElement('a');
    link.classList.add('rTapNumber238697');
    link.href = 'tel:03452032103';
    link.innerHTML = item.innerHTML;

    const par = item.parentNode;

    par.replaceChild(link, item);
  }));
})();

(function() {
  // This adds and removes classes to the body to indicate whether or not we
  // have sticky elements attached to the top of the viewport
  // we can then move other fixed elements based on this
  const body = document.body;

  const stickyEls = document.querySelectorAll('.sticky-top');

  const callback = function(e) {
    const entry = e[0];

    const rect = entry.boundingClientRect;

    if (rect.y <= 1 ) {
      body.classList.add('has-sticky-top');
      body.setAttribute('data-sticky-top-height', rect.height);
    }

    if (rect.height + rect.y <= 5 || rect.y > 1) {
      body.classList.remove('has-sticky-top');
      body.removeAttribute('data-sticky-top-height');
    }
  };

  const stickyObserver = new IntersectionObserver(callback, {
    rootMargin: '-1px 0px -1px 0px',
    threshold: [0, 0.2, 0.4, 0.6, 0.8, 1],
  });

  stickyEls.forEach((el) => {
    stickyObserver.observe(el);
  });
})();
